import deprecatedColors from "./deprecated_colors";

export enum Themes {
  Base,
  Admin,
  Test,
}

const deprecatedTheme = {
  VARIATION: Themes.Base,
  name: "Deprecated Theme",
  font: {
    family: {
      header: '"Open Sans", sans-serif',
      body: "Lato, sans-serif",
      label: "Lato, sans-serif",
    },
    size: {
      header: {
        one: "36px",
        two: "30px",
        three: "24px",
        four: "18px",
        five: "16px",
        six: "14px",
      },
      body: {
        one: "16px",
        two: "14px",
        three: "12px",
      },
      label: {
        one: "12px",
        two: "10px",
      },
    },
    weight: {
      light: 300,
      normal: 400,
      bold: 600,
    },
  },
  deprecatedColors: {
    primary: {
      extraDark: deprecatedColors.teal.extraDark,
      dark: deprecatedColors.cyan.dark,
      normal: deprecatedColors.cyan.normal,
      light: deprecatedColors.teal.light,
      extraLight: deprecatedColors.teal.extraLight,
    },
    secondary: {
      extraDark: deprecatedColors.purple.extraDark,
      dark: deprecatedColors.purple.dark,
      normal: deprecatedColors.purple.normal,
      light: deprecatedColors.purple.light,
      extraLight: deprecatedColors.purple.extraLight,
    },
    accent: {
      one: "#1F1F3D",
      two: "#4D4D7A",
      three: "#1B3F64",
      four: "#386592",
      five: "#018596",
      six: "#19B6CA",
      seven: "#128566",
      eight: "#2EC196",
    },
    error: deprecatedColors.red.normal,
    success: deprecatedColors.green.normal,
    warning: deprecatedColors.yellow.normal,
    warningDark: deprecatedColors.yellow.dark,
    text: {
      normal: deprecatedColors.gray.four,
      light: deprecatedColors.gray.ten,
      positive: deprecatedColors.green.normal,
      neutral: deprecatedColors.yellow.dark,
      negative: deprecatedColors.red.normal,
    },
    white: deprecatedColors.white,
    gray: {
      one: deprecatedColors.gray.one,
      two: deprecatedColors.gray.two,
      three: deprecatedColors.gray.three,
      four: deprecatedColors.gray.four,
      five: deprecatedColors.gray.five,
      six: deprecatedColors.gray.six,
      seven: deprecatedColors.gray.seven,
      eight: deprecatedColors.gray.eight,
      nine: deprecatedColors.gray.nine,
      ten: deprecatedColors.gray.ten,
      eleven: deprecatedColors.gray.eleven,
      twelve: deprecatedColors.gray.twelve,
      thirteen: deprecatedColors.gray.thirteen,
    },
    background: deprecatedColors.gray.twelve,
  },
  deprecatedSpacing: {
    component: {
      one: "2px",
      two: "4px",
      three: "8px",
      four: "12px",
      five: "16px",
      six: "24px",
      seven: "32px",
      eight: "40px",
      nine: "48px",
    },
    layout: {
      one: "16px",
      two: "24px",
      three: "32px",
      four: "48px",
      five: "64px",
      six: "96px",
      seven: "128px",
      eight: "192px",
      nine: "256px",
    },
  },
  deprecatedBorder: {
    weight: {
      normal: "1px",
      heavy: "2px",
    },
    radius: {
      normal: "4px",
      large: "6px",
      round: "100px",
      circle: "50%",
    },
  },
  deprecatedElevation: {
    one: "0px 2px 6px rgba(39, 51, 71, 0.08), 0px 1px 1px rgba(39, 51, 71, 0.1), 0px 1px 3px rgba(39, 51, 71, 0.16)",
    two: "0px 3px 1px rgba(39, 51, 71, 0.08), 0px 2px 2px rgba(39, 51, 71, 0.1), 0px 1px 5px rgba(39, 51, 71, 0.16)",
    three:
      "0px 3px 3px rgba(39, 51, 71, 0.08), 0px 3px 4px rgba(39, 51, 71, 0.1), 0px 1px 8px rgba(39, 51, 71, 0.16)",
    four: "0px 1px 10px rgba(39, 51, 71, 0.08), 0px 4px 5px rgba(39, 51, 71, 0.1), 0px 2px 4px rgba(39, 51, 71, 0.16)",
    six: "0px 1px 18px rgba(39, 51, 71, 0.08), 0px 6px 10px rgba(39, 51, 71, 0.1), 0px 3px 5px rgba(39, 51, 71, 0.16)",
    eight:
      "0px 3px 4px rgba(39, 51, 71, 0.08), 0px 8px 10px rgba(39, 51, 71, 0.1), 0px 5px 5px rgba(39, 51, 71, 0.16)",
    twelve:
      "0px 5px 22px rgba(39, 51, 71, 0.08), 0px 12px 17px rgba(39, 51, 71, 0.1), 0px 7px 8px rgba(39, 51, 71, 0.16)",
  },
  deprecatedBreakpoints: {
    small: "only screen and (max-width: 600px)",
    medium: "only screen and (max-width: 800px)",
    large: "only screen and (max-width: 1024px)",
  },
};

export type Theme = typeof deprecatedTheme;

export default deprecatedTheme;
